/* eslint-disable */

import { APIClient } from "./_api";
const endpoint = "/State";

export function getAll(query) {
  return APIClient.post(`${endpoint}/filter`, query);
}

export function getAllState() {
  return APIClient.get(`${endpoint}`);
}

export function editTax(query) {
  return APIClient.put(`/Tax/${query.id}`, query.data);
}

export function createTax(query) {
  return APIClient.post(`/Tax`, query);
}
